import { Navigate, useLocation } from "react-router-dom";
import { AuthStore } from "../auth/authStore";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const token = AuthStore.getToken();

  // ❌ Belum login
  if (!token) {
    return (
      <Navigate
        to="/admin"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}
